import {Component} from '@angular/core';
import {ViewController, NavParams} from 'ionic-angular';
import {MembershipService} from '../../../../profile/membership/membership.service';

@Component({
  selector: 'page-beauty-extra-class',
  templateUrl: 'beauty-extra-class.html'
})
export class BeautyExtraClassPage {
  public price: number;

  constructor(private readonly viewCtrl: ViewController,
              private readonly navParams: NavParams,
              public membershipService: MembershipService,
  ) {
    this.price = this.navParams.get('price');
  }

  dismissModal(extras = false) {
    this.viewCtrl.dismiss(extras);
  }

  accept() {
    this.dismissModal(true)
  }

  cancel() {
    this.dismissModal()
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/beauty-class/beauty-confirm/beauty-extra-class/beauty-extra-class.ts